/*!
 * Stimpack Control - Media
 *
 * @version : 1.0.0
 */

import { spIsBase64, spBase64Encode, spBase64Decode } from '../utilities/utilities';

(function($) {

    var spControlBackground = function(root, options)
    {
        var _t = this,
            root = $(root);

        this.o = $.extend({
            //multiple        : false,
            selectors : {
                encodedOutput   : '.sp-control-background-encoded-output'
            }
        }, options);

        this.el = {
            root            : root,
            add             : root.find('.sp-control-background-add'),
            encodedOutput   : root.find(this.o.selectors.encodedOutput)
        };

        console.log(this.o);

        this.init();
    };

    /*
     * Get value
     */
    spControlBackground.prototype.init = function()
    {
        var _t = this;

        this.el.root.on('change', 'select', function() {
            _t.refresh();
        });

        this.el.root.on('input', 'input', function() {
            _t.refresh();
        });

        this.el.root.find('.sp-control-media').on('spControlMedia::change', function() {
            _t.refresh();
        });
    }

    /*
     * Refresh
     */
    spControlBackground.prototype.refresh = function()
    {
        this.updateEncodedOutput(this.getValue());
    }

    /*
     * Get value
     */
    spControlBackground.prototype.getValue = function()
    {
        var json = this.el.root.find('[name' + (this.o.name ? '*="' + this.o.name + '"' : '') + ']:not(' + this.o.selectors.encodedOutput + ')').serializeJSON({useIntKeysAsArrayIndex: false});

        if (typeof json === 'object')
        {
            if (typeof json[this.o.name] === 'object')
            {
                json = json[this.o.name];
            }
            else if (typeof json.acf === 'object')
            {
                json = json.acf;
                json = json[Object.keys(json)[0]];
            }

            return json;
        }
    };

    /*
     * Update json output
     */
    spControlBackground.prototype.updateEncodedOutput = function(value)
    {
        if (this.el.encodedOutput.length > 0)
        {
            console.log(value);
            value = typeof value === 'object' ? spBase64Encode(JSON.stringify(value)) : null;
            this.el.encodedOutput.val(value);
        }
    }


    $.fn.spControlBackground = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-control-background');

            $(this).attr('data-sp-control-background', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, JSON.parse(spBase64Decode(_options)));
                }
            }

            this.spControlBackground = new spControlBackground(this, options);
        });
    };

    // Declaration
    $('[data-sp-control-background]').each(function() {
        $(this).spControlBackground();
    });

})(jQuery);
